var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 28V21.5C11.5 20.6716 12.1716 20 13 20H16C16.8284 20 17.5 20.6716 17.5 21.5V28M17.5 28H23.5V4.72727M17.5 28H27.5V14.3333M3.5 28H5.5M29.5 28H5.5M3.5 12L9.5 9.81818M25.5 4L23.5 4.72727M23.5 13L27.5 14.3333M29.5 15L27.5 14.3333M9.5 9.81818V4H5.5V28M9.5 9.81818L23.5 4.72727",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouses);
export default __webpack_public_path__ + "static/media/houses.7eb310e90dfd7e6165414aeddc928e6f.svg";
export { ForwardRef as ReactComponent };